import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "row mt-4" }
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { style: {"height":"37px","display":"block","margin-top":"12px"} }
const _hoisted_11 = { class: "col-sm-12" }
const _hoisted_12 = { class: "col-sm-12" }
const _hoisted_13 = { class: "col-sm-12" }
const _hoisted_14 = { class: "col-sm-12" }
const _hoisted_15 = { class: "text-center mt-3" }
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Edit Production Process",
          text: "Edit Production Process"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Selected item",
                text: "Selected item"
              })
            ]),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.modelToEdit.name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Width (cm)",
            labelValue: "Width (cm)",
            placeholderKey: "Width (cm)",
            placeholderValue: "Width (cm)",
            modelValue: _ctx.model.width,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.width) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Thickness (cm)",
            labelValue: "Thickness (cm)",
            placeholderKey: "Thickness (cm)",
            placeholderValue: "Thickness (cm)",
            modelValue: _ctx.model.thickness,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.thickness) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Density (g/cm3)",
            labelValue: "Density (g/cm3)",
            placeholderKey: "Density (g/cm3)",
            placeholderValue: "Density (g/cm3)",
            modelValue: _ctx.model.density,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.density) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Length (cm)",
            labelValue: "Length (cm)",
            placeholderKey: "Length (cm)",
            placeholderValue: "Length (cm)",
            modelValue: _ctx.model.length,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.length) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: _ctx.disabled,
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Edit",
            text: "Edit"
          })
        ], 8, _hoisted_16)
      ])
    ])
  ]))
}